import React, { Component } from 'react';
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CircularProgress } from 'material-ui/Progress';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';


import DataTable from './datatable';

import ContainerHeader from '../../../components/ContainerHeader/index';
import * as teamdetails from '../../../actions/teamdetails';

class TeamList extends Component {

    componentDidMount() {
        // console.log('props', this.props)
        this.props.actions.fetchTeamDetailsList();
    }

    render() {
        const { getDataList, match } = this.props;

        let dataList = <tr><td></td></tr>;
        let message = null;
        // console.log('getDataList', getDataList);
        if (getDataList && getDataList.Status) {
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        else if (getDataList && getDataList.teamdetailsList && getDataList.teamdetailsList.length > 0) {
            // dataList = getDataList.teamdetailsList.map((_data, index) => {
            //     return (<TableCell key={index} data={_data} index={index} />);
            // })
        }

        return (
            <div className="slideInUpTiny ">
            {message}
                <ContainerHeader title="Team List" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                {/* <h1 className="bg-primary text-white p-3 mb-0">Team List</h1> */}
                                <DataTable data={getDataList && getDataList.teamdetailsList && getDataList.teamdetailsList.length > 0 ? getDataList.teamdetailsList : null} />
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

function mapStateToProps(state, ownProps) {
    // console.log('state=>', state)
    const { teamDetails } = state
    const { match } = ownProps

    return { getDataList: teamDetails, match }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(teamdetails, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(TeamList);



// WEBPACK FOOTER //
// ./app/teamdetails/teamlist/index.js